import { MAX_PAGE_SIZE, paginatedResponseSchema } from '@jaf/contracts';
import type { z } from 'zod';
import { httpClient } from './api';
import { requestJson } from './request';

/**
 * Busca todas as páginas de uma listagem (para seletores que precisam do conjunto inteiro) e
 * devolve os itens validados pelo contrato, na ordem do servidor.
 */
export async function fetchAllPages<Item extends z.ZodType>(
  url: string,
  item: Item,
  params: Record<string, string>,
  signal?: AbortSignal,
): Promise<z.output<Item>[]> {
  const schema = paginatedResponseSchema(item);
  const items: z.output<Item>[] = [];
  let page = 1;
  let pageCount = 1;
  do {
    const response = await requestJson(httpClient, schema, {
      method: 'GET',
      url,
      params: { ...params, page, pageSize: MAX_PAGE_SIZE },
      ...(signal === undefined ? {} : { signal }),
    });
    items.push(...response.items);
    if (page === 1) pageCount = Math.ceil(response.total / MAX_PAGE_SIZE);
    if (response.items.length === 0) break;
    page += 1;
  } while (page <= pageCount);
  return items;
}
